import { render, staticRenderFns } from "./updateExamClassDialog.vue?vue&type=template&id=42c6ee90&scoped=true"
import script from "./updateExamClassDialog.vue?vue&type=script&lang=js"
export * from "./updateExamClassDialog.vue?vue&type=script&lang=js"
import style0 from "./updateExamClassDialog.vue?vue&type=style&index=0&id=42c6ee90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c6ee90",
  null
  
)

export default component.exports